// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___2zl_5","withHorizontalToggle":"styles__withHorizontalToggle___nqcbF","withSmallToggle":"styles__withSmallToggle___23fCT"};